import {getArea} from '@apps-common/geocorn-sdk/geom/cea.js';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import {pink} from '@mui/material/colors';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import React from 'react';
import AreaLegend from './AreaLegend.jsx';

const AlternateCard = ({
  originalFeature,
  alternateFeature,
  validationErrorMessages = [],
}) => {
  return (
    <Card>
      <CardHeader
        title={alternateFeature.properties.technique}
        subheader="This feature has been simplified and/or corrected"
        slotProps={{
          title: {
            variant: 'subtitle1',
          },
          subheader: {
            variant: 'body2',
          },
        }}
      />

      <CardContent>
        <Typography variant="body2">
          {`Reason${validationErrorMessages.length > 1 ? 's' : ''}:`}
        </Typography>

        <Box component="ul" sx={{paddingInlineStart: 4, marginBlockStart: 1}}>
          {validationErrorMessages.map(message => (
            <li key={message}>
              <Typography variant="body2">{message}</Typography>
            </li>
          ))}
        </Box>

        <Stack sx={{gap: 1}}>
          {originalFeature && (
            <AreaLegend
              prefix="Original"
              color="primary"
              squareMeters={getArea(originalFeature.geometry)}
            />
          )}

          {alternateFeature && (
            <AreaLegend
              prefix="Simplified"
              color={pink}
              squareMeters={alternateFeature.properties.area}
            />
          )}
        </Stack>
      </CardContent>
    </Card>
  );
};

AlternateCard.propTypes = {
  originalFeature: PropTypes.object,
  alternateFeature: PropTypes.object,
  validationErrorMessages: PropTypes.array,
};

export default AlternateCard;
